import {
  McpAuthorizationRequestSchema,
  type McpAuthorizationRequest,
} from '@erp/rpc';

/**
 * Decode the authorization request the backend forwards as one base64url
 * JSON `request` param (see the MCP /oauth/authorize endpoint). Sent opaque so
 * the router's JSON search parsing can't reinterpret values like `state=123`.
 * Returns null when it's missing or malformed.
 */
export function decodeConsentRequest(
  encoded: string | undefined,
): McpAuthorizationRequest | null {
  if (!encoded) return null;
  try {
    const base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
    const bytes = Uint8Array.from(atob(base64), (char) => char.charCodeAt(0));
    const parsed = McpAuthorizationRequestSchema.safeParse(
      JSON.parse(new TextDecoder().decode(bytes)),
    );
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}
